import VariantSelectorModal from './VariantSelectorModal';
import { useVariantSelectorModal } from './use-variant-selector-modal';

/**
 * The "Learn More" link and the modal it opens, shared by the dropdown and
 * button grid blocks. Renders nothing when Contentstack has no link copy.
 *
 * Owns the open/close state so the blocks don't have to. That state comes from
 * the deprecated `useVariantSelectorModal`; the swatch and column selectors use
 * the shared `useModal` provider instead.
 * TODO: Replace this deprecated modal path with `useModal` so all selectors use
 * the same shared modal flow.
 */
export default function VariantSelectorModalLink({ modal }) {
  const { modalOpen, showModal, hideModal } = useVariantSelectorModal();

  if (!modal?.link_copy) {
    return null;
  }

  return (
    <>
      <button
        className="body-s text-dawn-grey-60 cursor-pointer underline"
        onClick={showModal}
      >
        Learn More
      </button>
      <VariantSelectorModal
        isOpen={modalOpen}
        hideModal={hideModal}
        modalCopy={modal.modal_content}
        modalHeading={modal.modal_heading}
      />
    </>
  );
}
